import React from "react";
import "./Sidebar.css";
import "./Home.css";
import Sidebar from "./Sidebar";
import Front from "./Front";
import Nav from "./Nav";
import { motion } from "framer-motion";

const Home = () => {
  const container = {
    hidden: {
      x: "-30%",
      opacity: 0,
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        ease: "easeInOut",
        type: "spring",
        delay: 0.2,
        duration: 0.5,
        stiffness: 30,
      },
    },
    exit: {
      x: "30%",
      opacity: 0,
      transition: {
        ease: "easeInOut",
        type: "spring",
        delay: 0.2,
        duration: 0.5,
        stiffness: 30,
      },
    },
  };
  return (
    <motion.main
      className="portfolio"
      variants={container}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <Sidebar />
      <Front />
      <Nav />
    </motion.main>
  );
};

export default Home;
